<template>
    <Form id="app"></Form>
</template>

<script>
    import Form from "./forms/FORWARD_ORDER";

    export default {
        name: "App",
        components: {
            Form
        }
    }
</script>

<style lang="scss">
    @import './styles';
</style>
